import React, { Component } from "react";
import './learning-resources.scss'
import { getImageSource } from '../../utility/image-source'
import { Constants, ImageConstants } from '../../constants/constants'
import Path from '../routes/routes-path'
import FilterComponent from "./filter/filter";
import MasterDataApi from '../../apis/master-data';
import ChapterDetails from "./chapter-details/chapter-details";



class LearningResources extends Component {

    state = {
        chapterList: []
    }


    componentDidMount() {
        
        console.log(this.props)

        if(this.props.history?.location?.state?.from === "NEW_HOMEWORK_CREATION") {
            this.setState(
                {
                    showChapterInfo: true,
                    selectedChapterKey: this.props.history.location.state.chapterKey,
                    selectedChapterTitle: this.props.history.location.state.chapterTitle,
                    selectedClass: this.props.history.location.state.selectedClass,
                    selectedBoard : this.props.history.location.state.selectedBoard,
                    masterDataId : this.props.history.location.state.masterDataId
                }
            )
                
            this.getChapters({class : this.props.history.location.state.selectedClass, board : this.props.history.location.state.selectedBoard})

        }


    }




    getChapters(payload = {}) {

        console.log(payload)

         this.setState({selectedClass : payload.class, selectedBoard : payload.board})

        // if (!payload.class) payload.class = this.state.selectedClass
        // if (!payload.board) payload.board = this.state.selectedBoard

        MasterDataApi.getChapterList(payload)
            .then(response => {
                let chapters = []
                response = response.data
                console.log(response)
                this.setState({ masterDataId: response._id })
                for (let i = 0; i < response.chapters.length; i++) {
                    let chapter = response.chapters[i], concepts = []
                    chapters.push({
                        title: chapter.title,
                        value: chapter.key,
                        chapterImageURL: chapter.imageUrl
                    })

                    // for (let j = 0; j < chapter.concepts?.length; j++) {
                    //     let concept = chapter.concepts[j]
                    //     concepts.push({
                    //         title: concept.title,
                    //         value: concept.key,
                    //         order: j + 1
                    //     })
                    //     // this.buildElosDropdown(concept)
                    // }

                    // this.conceptHash[chapter.key] = concepts
                }

                // chapters.push({value:'ALL',title:'ALL'})
                console.log(chapters)
                this.setState({ chapterList: chapters, orginalChapterList : chapters, selectedChapter: "" })
                this.reloadDropdown()
            }).catch(err => {

                if(err.response && err.response.status === 400) {
                    this.setState({chapterList : []})
                }
            })
    }


    showChapterDetails(chapter, index) {

        this.setState(
            {
                showChapterInfo: true,
                selectedChapterKey: chapter.value,
                selectedChapterTitle: chapter.title,
                selectedClass: this.state.selectedClass,
                selectedChapterIndex: index,
                chapterImageURL : chapter.chapterImageURL
            }
        )

    }

    hideChapterDetails() {
        this.setState({ showChapterInfo: false, selectedChapterKey: "" })
    }

    changeChapterList(searchText) {
        console.log(searchText)

        let orginalChapterList = this.state.orginalChapterList

        let value = searchText
        console.log(orginalChapterList)

        console.log('1')

        if(value && value.length) {
        let chapterList = orginalChapterList.filter(option => option[`title`].toLowerCase().includes(value.toLowerCase()));
        this.setState({ chapterList: chapterList });
        }else {
            this.setState({ chapterList: orginalChapterList });
        }
            
    }



    render() {

        if (this.state.showChapterInfo) {
            return <ChapterDetails
                back={() => this.hideChapterDetails()}
                chapterKey = {this.state.selectedChapterKey}
                chapterTitle = {this.state.selectedChapterTitle}
                selectedClass = {this.state.selectedClass}
                selectedBoard = {this.state.selectedBoard}
                masterDataId = {this.state.masterDataId}
                chapterImageURL = {this.state.chapterImageURL}
                delegate = {this}
            />
        }


        return (
            <div className="learning-resources mb-5">
                {/* <div className='mb-5 cursor-pointer' onClick={_ => this.props.history.push({ pathname: Path.PERSONALISED_HOMEWORK, showList: true })}>
                    <img className='ad-banner' src={getImageSource(ImageConstants.AD_BANNER_1)} />
                </div> */}
                <div className="menu-heading">Teaching Resources</div>
                <div className="mt-3">
                    <FilterComponent getChapterList={(payload) => this.getChapters(payload)} changeChapterList = {(searchText) => this.changeChapterList(searchText) } />
                </div>
                <div className="mt-5">
                    {
                        this.state.chapterList.length ? this.state.chapterList.map((chapter, index) => (

                            <div className={`chapter-card cursor-pointer  mb-1 ${this.state.selectedChapterIndex === index ? 'enable' : ''}`}
                            onClick={() => this.showChapterDetails(chapter, index)}>
                                <div>
                                    <img className="chapter-icon cursor-pointer" src={chapter.chapterImageURL ? chapter.chapterImageURL : getImageSource(ImageConstants.CHAPTER_ICN)} />
                                    <span className="chapter-title cursor-pointer ml-3" onClick={() => this.showChapterDetails(chapter, index)} >{chapter.title}</span>
                                </div>
                                <div>
                                    <img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} onClick={() => this.showChapterDetails(chapter, index)} />
                                </div>
                            </div>


                        )) : <div className="chapter-card justify-content-center">
                            <div>Please Select a Board and Class</div>
                        </div>
                    }
                </div>
            </div>
        )






    }
}

export default LearningResources